import { MutationResponse, OrgNode } from '../../../services/orgs/interfaces';
import OrgsService from '../../../services/orgs';
import { StripeEnv } from '../../../util/enums';
import { ProviderEntities } from './providerEntities';

export async function createOrgsEntities({
  providerEntities,
  kybId,
  org,
  stripeEnv,
  currentUserId,
  kycId,
  kycIsOwner,
}: {
  providerEntities: ProviderEntities;
  kybId: string;
  org: OrgNode;
  stripeEnv: StripeEnv;
  currentUserId: string;
  kycId: string;
  kycIsOwner: boolean;
}): Promise<MutationResponse> {
  const res = await OrgsService.createFinancialAccountNode({
    kybId,
    orgId: org.id,
    processor: 'STRIPE',
    acctId: providerEntities.stripeEntities?.connectAccountId,
    stripeEnv,
  });
  await OrgsService.financialAccountUserAssociate({
    finAcctId: res.properties.finAcctId,
    userId: currentUserId,
    isBeneficialOwner: kycIsOwner,
    isRepresentative: true,
    kycId,
    personId: providerEntities.stripeEntities?.personId,
  });
  return res;
}
